import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { applyVisiteUpdate, hasVisiteUpdate, VISITE_UPDATE_EVENT } from "../../lib/visite/sw";

export default function VisiteUpdateBanner() {
  const [show, setShow] = useState(() => hasVisiteUpdate());
  useEffect(() => {
    const on = () => setShow(true);
    window.addEventListener(VISITE_UPDATE_EVENT, on);
    return () => window.removeEventListener(VISITE_UPDATE_EVENT, on);
  }, []);
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="visite-update-banner"
      className="fixed inset-x-3 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-emerald-700 p-3 pl-4 text-white shadow-xl"
      style={{ top: "calc(0.75rem + env(safe-area-inset-top))" }}
    >
      <p className="flex-1 text-sm font-medium">È disponibile una nuova versione di Visite.</p>
      <button
        type="button"
        onClick={() => applyVisiteUpdate()}
        className="inline-flex h-11 items-center gap-2 rounded-xl bg-white px-4 text-base font-semibold text-emerald-800"
      >
        <RefreshCw className="h-4 w-4" /> Aggiorna
      </button>
    </div>
  );
}
